/*
 * 权限码常量
 *
 * 初版维护
 * 系统已有所有权限码集合
 * 拥有列表查看权限的，就拥有其他权限，故而前端只校验是否有列表查看权限
 */

// 展会配置-列表查看权限【拥有列表查看权限，相应的增删改权限就具备】 模拟 配置管理员(当前登录拥有此能力、就是配置管理员，实际设计与角色无关)111 111
export const FIND_EXHI_PAGED_LIST = 'eventsgopublic$Service$ecr.eventsgo.exhibition.exhibitionService$findExhibitionConfigPagedList'

// 用户权限配置 - 列表查看权限【拥有列表查看权限，相应的增删改权限就具备】000
export const FIND_USER_PERMISSIONS = 'eventsgocommon$Service$User$create'
